import { usePlanFeaturesQuery } from '@/hooks/queries/use-plan-features-query';
import { usePaywall } from '@/hooks/use-paywall';
import { upgradeTierFor, type PlanLimit, type PlanQuotaMeta } from '@fluenceur/types';

/** Monthly counter links keep their feature and quota context in the shared picker. */
export function useQuotaUpgrade(limit: PlanLimit, quota: PlanQuotaMeta) {
  const { planTier } = usePlanFeaturesQuery();
  const { openPlanLimitModal } = usePaywall();

  return () => {
    openPlanLimitModal({
      limit,
      currentTier: planTier,
      targetTier: upgradeTierFor(limit, planTier),
      used: quota.used,
      ...(quota.limit !== null && { max: quota.limit }),
      ...(quota.resetsAt && { resetsAt: quota.resetsAt }),
    });
  };
}
